import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { cn } from '../lib/utils';
interface ComboCardProps {
  title: string;
  price: string;
  originalPrice: string;
  discount: string;
  features: string[];
  isRecommended?: boolean;
  isPremium?: boolean;
  onBuy: () => void;
  image?: string;
}
export function ComboCard({
  title,
  price,
  originalPrice,
  discount,
  features,
  isRecommended,
  isPremium,
  onBuy,
  image
}: ComboCardProps) {
  return <motion.div whileHover={{
    y: -5
  }} className={cn('relative flex flex-col p-6 rounded-2xl border bg-zinc-900', isRecommended ? 'border-green-500 shadow-[0_0_30px_rgba(34,197,94,0.15)] scale-105 z-10' : 'border-zinc-800 hover:border-zinc-700')} data-id="element-61">
      {isRecommended && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-green-500 text-black font-bold text-xs uppercase px-4 py-1 rounded-full shadow-lg" data-id="element-62">
          Más Vendido
        </div>}

      {image && <div className="mb-6 rounded-lg overflow-hidden h-48 bg-zinc-950 relative flex items-center justify-center" data-id="element-63">
          <img src={image} alt={title} className="h-full w-auto object-contain drop-shadow-xl" data-id="element-64" />
          <div className="absolute top-2 right-2 bg-red-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-65">
            -{discount}
          </div>
        </div>}

      <h3 className={cn('text-xl font-bold mb-2', isRecommended ? 'text-green-500' : 'text-white')} data-id="element-66">
        {title}
      </h3>

      <div className="flex items-baseline gap-2 mb-1" data-id="element-67">
        <span className="text-zinc-500 line-through text-sm" data-id="element-68">
          ARS {originalPrice}
        </span>
      </div>
      <div className="flex items-baseline gap-1 mb-6" data-id="element-69">
        <span className="text-3xl font-bold text-white" data-id="element-70">ARS {price}</span>
      </div>

      <ul className="space-y-3 mb-8 flex-1" data-id="element-71">
        {features.map((feature, i) => <li key={i} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-72">
            <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-73" />
            <span data-id="element-74">{feature}</span>
          </li>)}
      </ul>

      <Button variant={isRecommended ? 'primary' : 'secondary'} fullWidth onClick={onBuy} className="mt-auto" data-id="element-75">
        COMPRAR AHORA
      </Button>

      <p className="text-center text-xs text-zinc-500 mt-3" data-id="element-76">
        Acceso inmediato • Pago seguro
      </p>
    </motion.div>;
}